export const styles = theme => ({
  
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  root: {
    width: '100%',
    marginTop: theme.spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
  },
   icon: {
    fontSize: 40,
    float: 'right',
    cursor: 'pointer',
  },
  iconWrap: {
    fontSize: 40,
    float: 'right',
    cursor: 'pointer',
    padding: '4px'
  },
  frameTitle: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(7),
    alignItems: 'center'
  },
  frameTitleSearch: {
    display: 'flex',
    justifyContent: 'space-between', 
  },
  frameTitleFeature: {
    marginBottom: '1.5rem',
    marginTop: '1.5rem',
  },
  paperMenuGroup: {
    flex: "1 1 100%",
    marginBottom: theme.spacing(2),
    position: 'relative'
  },
  rootMenuItem: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  paperMenuItem: { 
    [theme.breakpoints.down('md')]: {
      height: 'auto'
    },
    position: 'relative'
  },
  paperMenuItemFeatured: { 
    [theme.breakpoints.down('md')]: {
      height: 'auto'
    },
    position: 'relative'
  },
  hiddenBreakPoint: {
    display: 'block',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  showBreakPoint: {
      display: 'none',
      [theme.breakpoints.down('md')]: {
        display: 'block'
      }
  }
  
});
